import { ColonistOneTimePurchaseType, LobbyImage } from '@colonist/types';
import { StoreProductType, StripeCheckoutTypes } from './BaseColonistStoreProduct.ts';
export class ColonistOneTimePurchaseProduct {
    getProductName() {
        return this.title;
    }
    getDefaultPrice() {
        return `$${this.price / 100}`;
    }
    getUSDPrice() {
        return this.price / 100;
    }
    static getOneTimePurchaseProduct(oneTimePurchaseType, itemQuantity = 1) {
        const product = this.products.get(oneTimePurchaseType);
        product.itemQuantity = itemQuantity;
        return product;
    }
    static initProducts(discordSKUIds) {
        this.products.set(ColonistOneTimePurchaseType.Holiday2023AllAccessPass, new ColonistOneTimePurchaseProduct({
            type: ColonistOneTimePurchaseType.Holiday2023AllAccessPass,
            title: {
                key: 'strings:storePage.sections.holiday_sale.title',
                options: {
                    context: 'full'
                }
            },
            price: 699,
            discordSKUId: discordSKUIds.passAllAccessHoliday2023,
            lobbyImage: LobbyImage.StoreMembershipHoliday2023,
            isActive: ()=>false
        }));
        this.products.set(ColonistOneTimePurchaseType.GiftPlusMonthly, new ColonistOneTimePurchaseProduct({
            type: ColonistOneTimePurchaseType.GiftPlusMonthly,
            title: {
                key: 'strings:storePage.membership.title.plus'
            },
            price: 899,
            discordSKUId: discordSKUIds.giftMembershipPlus,
            lobbyImage: LobbyImage.StoreMembershipPlus,
            isActive: ()=>true
        }));
        this.products.set(ColonistOneTimePurchaseType.GiftPremiumMonthly, new ColonistOneTimePurchaseProduct({
            type: ColonistOneTimePurchaseType.GiftPremiumMonthly,
            title: {
                key: 'strings:storePage.membership.title.premium'
            },
            price: 1899,
            discordSKUId: discordSKUIds.giftMembershipPremium,
            lobbyImage: LobbyImage.StoreMembershipPremium,
            isActive: ()=>true
        }));
        this.products.set(ColonistOneTimePurchaseType.GiftEliteMonthly, new ColonistOneTimePurchaseProduct({
            type: ColonistOneTimePurchaseType.GiftEliteMonthly,
            title: {
                key: 'strings:storePage.membership.title.elite'
            },
            price: 2499,
            discordSKUId: discordSKUIds.giftMembershipElite,
            lobbyImage: LobbyImage.StoreMembershipElite,
            isActive: ()=>true
        }));
        this.products.set(ColonistOneTimePurchaseType.GiftPlusYearly, new ColonistOneTimePurchaseProduct({
            type: ColonistOneTimePurchaseType.GiftPlusYearly,
            title: {
                key: 'strings:storePage.membership.title.plus'
            },
            price: 8388,
            discordSKUId: discordSKUIds.giftMembershipPlusYearly,
            lobbyImage: LobbyImage.StoreMembershipPlus,
            isActive: ()=>true
        }));
        this.products.set(ColonistOneTimePurchaseType.GiftPremiumYearly, new ColonistOneTimePurchaseProduct({
            type: ColonistOneTimePurchaseType.GiftPremiumYearly,
            title: {
                key: 'strings:storePage.membership.title.premium'
            },
            price: 17988,
            discordSKUId: discordSKUIds.giftMembershipPremiumYearly,
            lobbyImage: LobbyImage.StoreMembershipPremium,
            isActive: ()=>true
        }));
        this.products.set(ColonistOneTimePurchaseType.GiftEliteYearly, new ColonistOneTimePurchaseProduct({
            type: ColonistOneTimePurchaseType.GiftEliteYearly,
            title: {
                key: 'strings:storePage.membership.title.elite'
            },
            price: 23988,
            discordSKUId: discordSKUIds.giftMembershipEliteYearly,
            lobbyImage: LobbyImage.StoreMembershipElite,
            isActive: ()=>true
        }));
    }
    constructor(source){
        this.storeProductType = StoreProductType.OneTimePurchase;
        this.stripeCheckoutType = StripeCheckoutTypes.Payment;
        this.itemQuantity = 1;
        Object.assign(this, source);
    }
}
ColonistOneTimePurchaseProduct.products = new Map();
